export default (postalOperators) => postalOperators
  .filter((postalOperator) => postalOperator.mailProcessingCenters && postalOperator.mailProcessingCenters.length)
  .map((postalOperator) => {
    const childrenMailProcessingCenter = postalOperator.mailProcessingCenters
      .map((mailProcessingCenter) => ({
          value: mailProcessingCenter.code,
          label: `${mailProcessingCenter.code} - ${mailProcessingCenter.name ? mailProcessingCenter.name : ''}`,
        }));
    return {
      value: postalOperator.postalOperatorCode,
      label:
        (postalOperator.postalOperatorCode ? `${postalOperator.postalOperatorCode} - ` : '') + (postalOperator.postalOperatorName
        ? postalOperator.postalOperatorName : ''),
      children: childrenMailProcessingCenter,
    };
  });
